export const GET_TRACKS_START = 'GET_TRAKS_START';
export const GET_TRACKS_SUCCESS = 'GET_TRAKS_SUCCESS';
export const GET_TRACKS_FAIL = 'GET_TRAKS_FAIL';

export const GET_TRACK_BY_ID_START = 'GET_TRACK_BY_ID_START';
export const GET_TRACK_BY_ID_SUCCESS = 'GET_TRACK_BY_ID_SUCCESS';
export const GET_TRACK_BY_ID_FAIL = 'GET_TRACK_BY_ID_FAIL';

export const GET_TRACKS_STATUS_START = 'GET_TRACKS_STATUS_START';
export const GET_TRACKS_STATUS_SUCCESS = 'GET_TRACKS_STATUS_SUCCESS';
export const GET_TRACKS_STATUS_FAIL = 'GET_TRACKS_STATUS_FAIL';

export const GET_TRACK_SECTIONS_BY_ID_START = 'GET_TRACK_SECTIONS_BY_ID_START';
export const GET_TRACK_SECTIONS_BY_ID_SUCCESS = 'GET_TRACK_SECTIONS_BY_ID_SUCCESS';
export const GET_TRACK_SECTIONS_BY_ID_FAIL = 'GET_TRACK_SECTIONS_BY_ID_FAIL';

export const ADD_TRACK_TO_USER_PLAN_START = 'ADD_TRACK_TO_USER_PLAN_START';
export const ADD_TRACK_TO_USER_PLAN_SUCCESS = 'ADD_TRACK_TO_USER_PLAN_SUCCESS';
export const ADD_TRACK_TO_USER_PLAN_FAIL = 'ADD_TRACK_TO_USER_PLAN_FAIL';

export const DELETE_TRACK_FROM_STUDY_PLAN_START = 'DELETE_TRACK_FROM_STUDY_PLAN_START';
export const DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS = 'DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS';
export const DELETE_TRACK_FROM_STUDY_PLAN_FAIL = 'DELETE_TRACK_FROM_STUDY_PLAN_FAIL';

export const RESCHEDULE_USER_TRACK_START = 'RESCHEDULE_USER_TRACK_START';
export const RESCHEDULE_USER_TRACK_SUCCESS = 'RESCHEDULE_USER_TRACK_SUCCESS';
export const RESCHEDULE_USER_TRACK_FAIL = 'RESCHEDULE_USER_TRACK_FAIL';

export const GET_COLLECTION_TRACKS_START = 'GET_COLLECTION_TRACKS_START';
export const GET_COLLECTION_TRACKS_SUCCESS = 'GET_COLLECTION_TRACKS_SUCCESS';
export const GET_COLLECTION_TRACKS_FAIL = 'GET_COLLECTION_TRACKS_FAIL';

export const GET_TRACK_REPORT_START = 'GET_TRACK_REPORT_START';
export const GET_TRACK_REPORT_SUCCESS = 'GET_TRACK_REPORT_SUCCESS';
export const GET_TRACK_REPORT_FAIL = 'GET_TRACK_REPORT_FAIL';

export const CLEAR_COLLECTION_TRACKS = 'CLEAR_COLLECTION_TRACKS';

export const CLEAR_HAS_REWARDS = 'CLEAR_HAS_REWARDS';
